var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 15.9998C2.6665 8.63584 8.63584 2.6665 15.9998 2.6665C23.3638 2.6665 29.3332 8.63584 29.3332 15.9998C29.3332 23.3638 23.3638 29.3332 15.9998 29.3332C8.63584 29.3332 2.6665 23.3638 2.6665 15.9998ZM21.9505 11.7945L20.4972 21.0998C20.477 21.2279 20.4254 21.349 20.347 21.4523C20.2686 21.5555 20.1658 21.6377 20.0478 21.6915C19.9298 21.7453 19.8004 21.7689 19.671 21.7604C19.5416 21.7518 19.4164 21.7113 19.3065 21.6425L14.4385 18.5932C14.3374 18.5299 14.252 18.4444 14.1889 18.3431C14.1258 18.2418 14.0866 18.1275 14.0744 18.0088C14.0622 17.8901 14.0773 17.7702 14.1184 17.6582C14.1595 17.5462 14.2257 17.4451 14.3118 17.3625L18.3518 13.4905C18.3972 13.4478 18.3438 13.3772 18.2905 13.4092L12.4345 16.9132C12.0865 17.1225 11.6745 17.1945 11.2745 17.1172L9.1545 16.7078C8.38917 16.5598 8.28384 15.5092 9.0025 15.2118L20.3398 10.5252C20.5328 10.4455 20.7436 10.4186 20.9504 10.4473C21.1572 10.476 21.3526 10.5592 21.5166 10.6885C21.6806 10.8177 21.8073 10.9883 21.8835 11.1827C21.9598 11.3771 21.9829 11.5882 21.9505 11.7945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTelegram);
export default __webpack_public_path__ + "static/media/footer_telegram.5ae4aefddd8c4106aa7e679abcc25a5c.svg";
export { ForwardRef as ReactComponent };